<template>
  <div class="home">
    <!-- Banner -->
    <div class="banner">
      <img class="banner-img" src="@/assets/mobile/banner.jpg" alt="">
      <div class="title font-24" :class="{'line-small': $root.isEnglish}">
        <span class="weight-bold">{{$root.language.homeRow1}}</span>
        <span>{{$root.language.homeRow2}}</span>
      </div>
      <div class="title font-24 weight-bold text-red">{{$root.language.homeRow3}}</div>
      <ul class="weight-bold font-18 banner-ul">
        <li>
          <a-icon class="text-red" :style="iconColor" type="caret-right" />{{$root.language.homeRow4}}</li>
        <li>
          <a-icon class="text-red" :style="iconColor" type="caret-right" />{{$root.language.homeRow5}}</li>
        <li>
          <a-icon class="text-red" :style="iconColor" type="caret-right" />{{$root.language.homeRow6}}</li>
      </ul>
      <div class="font-14 banner-desc">
        <span class="text-red weight-bold">{{$root.language.homeRow7}}</span>
        <span>{{$root.language.homeRow8}}{{$root.language.homeRow9}}{{$root.language.homeRow10}}</span>
      </div>
    </div>

    <!-- Cloud Native -->
    <div class="cloud-native">
      <div class="cloud-img">
        <img src="@/assets/img/cloud.png" width="150">
        <div class="font-14 margin-top-25 cloud-title">
          <span class="weight-bold"><span class="text-red">{{$root.language.homeRow11}}</span>
            {{$root.language.homeRow12}}
          </span>{{$root.language.homeRow13}}
          {{$root.language.homeRow14}}
        </div>
      </div>
      <div class="bg-white cloud-engineering">
        <div class="flex">
          <img src="@/assets/img/digital.png" width="100" alt="">
          <div class="flex-item margin-left-15">
            <div class="font-16 weight-bold">{{$root.language.engineering}}</div>
            <ul class="font-14">
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.navigator}}</span></li>
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.pdm}}</span></li>
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.ppm}}</span></li>
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.npi}}</span></li>
            </ul>
            <SkewButton class="weight-bold font-12 text-center" width="110" :text="$root.language.homeRow15" @click="jumpProduct"></SkewButton>
          </div>
        </div>
      </div>

      <div class="text-center">
        <img src="@/assets/mobile/line.jpg" width="100" alt="">
      </div>

      <div class="bg-white cloud-factory">
        <div class="flex">
          <img src="@/assets/img/factory.png" width="100" alt="">
          <div class="flex-item margin-left-15">
            <div class="font-16 weight-bold">{{$root.language.factory}}</div>
            <ul class="font-14">
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.pqm}}</span></li>
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.deviceMate}}</span></li>
              <li class="padding-y-4"><a-icon type="caret-right" /><span class="weight-bold text-gray">{{$root.language.productionLineEngine}}</span></li>
            </ul>
            <SkewButton class="weight-bold font-12 text-center" width="110" :text="$root.language.homeRow15" @click="jumpProduct"></SkewButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Us -->
    <div class="join-us">
      <div class="font-22 text-red weight-bold line-normal">{{$root.language.homeRow17}} {{$root.language.homeRow18}}</div>
      <div class="relative line"></div>
      <div class="font-14 weight-bold margin-y-15">
        {{$root.language.homeRow19}}
        {{$root.language.homeRow20}}
        {{$root.language.homeRow21}}
      </div>
      <div class="text-center">
        <SkewButton @click="showJoinUs" class="weight-bold font-12" width="120" :text="$root.language.homeRow26"></SkewButton>
      </div>
      <a-modal v-model="visible" :closable="false" :mask="false" centered :footer="null" width="100%" :bodyStyle="bodyStyle">
        <div class="font-22 text-red weight-bold">TALK TO US</div>
        <div class="message-body">
          <div class="message-form">
            <a-spin :spinning="loading">
              <a-form-model ref="ruleForm" class="form-label-none" :model="formData" :rules="rules">
                <a-form-model-item label="firstName" prop="firstName">
                  <a-input v-model="formData.firstName" :placeholder="$root.language.homeRow22" />
                </a-form-model-item>
                <a-form-model-item label="lastName" prop="lastName">
                  <a-input v-model="formData.lastName" :placeholder="$root.language.homeRow23" />
                </a-form-model-item>
                <a-form-model-item label="email" prop="email">
                  <a-input v-model="formData.email" :placeholder="$root.language.homeRow24" />
                </a-form-model-item>
                <a-form-model-item label="company" prop="company">
                  <a-input v-model="formData.company" :placeholder="$root.language.homeRow25" />
                </a-form-model-item>
                <a-form-model-item label="job" prop="job">
                  <a-input v-model="formData.job" :placeholder="$root.language.homeRow27" />
                </a-form-model-item>
                <a-form-model-item label="description" prop="description">
                  <a-textarea v-model="formData.description" :placeholder="$root.language.homeRow28" :rows="5" />
                </a-form-model-item>
                <a-form-model-item>
                  <div class="font-16">
                    * {{$root.language.homeRow29}}
                  </div>
                </a-form-model-item>
              </a-form-model>
              <div class="text-center">
                <SkewButton :text="$root.language.homeRow26" width="120" class="text-center weight-bold font-12"
              @click="handleSubmit"></SkewButton>
            </div>
            </a-spin>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title'
import SkewButton from '@/components/button-skew'
import {
  createApi
} from '@/api/user'

import Tools from '@/utils/validate'
export default {
  components: {
    // Title,
    SkewButton
  },
  data () {
    return {
      iconColor: {
        color: '#DA4026'
      },
      visible: false,
      rules: {
        firstName: [{
          required: true,
          message: 'Please input',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          message: 'Please input',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: 'Please input',
          trigger: 'blur'
        },
        {
          validator: Tools.email,
          trigger: 'change',
          message: 'Email is error'
        }
        ],
        company: [{
          required: false,
          message: 'Please input',
          trigger: 'blur'
        }]
      },
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        job: '',
        description: ''
      },
      loading: false,
      bodyStyle: {
        background: '#e8e2e2'
      }
    }
  },
  methods: {
    jumpProduct () {
      this.$router.push({
        path: '/products'
      })
    },
    showJoinUs () {
      this.visible = true
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.fetchCreate()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    resetForm () {
      this.loading = false
      this.$refs.ruleForm.resetFields()
    },

    fetchCreate () {
      this.$http({
        ...createApi,
        data: this.formData
      }).then(() => {
        this.$message.success('success')
        this.resetForm()
        this.visible = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err.msg)
      })
    },
    jumpLink (type) {
      if (type === 'in') {
        window.open('https://www.linkedin.com/company/3519789/')
      } else {
        window.open('https://mp.weixin.qq.com/s/kfaiJ3F_hUTJYKmKurIbvA')
      }
    }
  }
}

</script>

<style scoped>
  .banner {
    padding: 10px 15px;
  }
  .banner-img {
    width: 100%;
  }

  .banner-ul {
    margin-left: 20px;
  }

  .banner-desc {
    margin-bottom: 40px;
  }

  .cloud-native {
    padding: 15px 0;
    background-color: #E9E9E9;
  }

  .cloud-img {
    padding: 0 10px;
    text-align: center;
  }

  .cloud-title {
    margin-top: 15px;
    text-align: left;
  }

  .cloud-engineering {
    margin: 10px 10px 0 10px;
    padding: 20px;
  }

  .cloud-factory {
    margin: 0 10px;
    padding: 20px;
  }

  .text-gray {
    color: #737373;
  }

  .join-us {
    background-color: #E9E9E9;
    margin: 10px;
    padding: 20px;
  }

  .line {
    left: -30px;
    width: calc(100% + 30px);
    border-bottom: 3px solid #a3a3a3;
  }

  .padding-y-4 {
    padding: 5px 0;
  }

</style>
